import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import "../Footer/Footer.css";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram } from '@fortawesome/free-brands-svg-icons';  // Corrected import

const Footer = ({ footerlogo, alt, footerinfo, footerlink1, footerlink2, footerlink3, footerlink4, footerlink5, emailinfo }) => {

    const navigate = useNavigate();
    const location = useLocation();

    const handleInternalLinkClick = (event, targetId) => {
        event.preventDefault();
        if (location.pathname === '/home') {
            const section = document.getElementById(targetId);
            if (section) {
                const header = document.querySelector('header');
                const headerHeight = header ? header.offsetHeight : 0;
                const sectionPosition = section.getBoundingClientRect().top + window.scrollY;
                const offsetPosition = sectionPosition - headerHeight;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });

                // Update the URL without causing a reload
                window.history.pushState({}, '', `/home#${targetId}`);
            }
        } else {
            navigate(`/home#${targetId}`);
            window.scrollTo(0, 0);  // Scroll to top when navigating to a different page
        }
    };



    return (
        <>
            <footer className='footer'>
                <div className='footer-top'>
                    <Container>
                        <div className='footer-content'>
                            <div className='footer-left-part'>
                                <div className='footer-logo'>
                                    <Link to="/">
                                        <img src={footerlogo} alt={alt} className='img-fluid' />
                                    </Link>
                                </div>
                                <div className='footer-info'>
                                    <p>{footerinfo}</p>
                                </div>
                            </div>
                            <div className='footer-right-part'>
                                <div className='footer-menu-list'>
                                    <ul>
                                        <li><Link to="/home#features" onClick={(e) => handleInternalLinkClick(e, 'features')}>{footerlink1}</Link></li>
                                        <li><Link to="/home#video" onClick={(e) => handleInternalLinkClick(e, 'video')}>{footerlink2}</Link></li>
                                        <li><Link to="/home#about" onClick={(e) => handleInternalLinkClick(e, 'about')}>{footerlink3}</Link></li>
                                        <li><Link to="/home#reviews" onClick={(e) => handleInternalLinkClick(e, 'reviews')}>{footerlink4}</Link></li>
                                        <li><Link to="/home#plan" onClick={(e) => handleInternalLinkClick(e, 'plan')}>{footerlink5}</Link></li>
                                    </ul>
                                    <div className='footer-btn'>
                                        <Link to="/home#star-for-free" onClick={(e) => handleInternalLinkClick(e, 'star-for-free')} className='btn btn-blue'>Start for Free</Link>
                                    </div>
                                </div>
                                <div className='social-media-icon'>
                                    <ul>
                                        <li><Link to={`mailto:${emailinfo}`}>{emailinfo}</Link></li>
                                        <li><Link to="https://facebook.com" target='_blank'><FontAwesomeIcon icon={faFacebookF} /></Link></li>
                                        <li><Link to="https://instagram.com" target='_blank'><FontAwesomeIcon icon={faInstagram} /></Link></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </Container>
                </div>
                <div className='footer-bottom'>
                    <Container>
                        <div className='footer-bottom-content'>
                            <div className='footer-copyright'>
                                <p>© 2024 SpeedScan - All rights preserved.</p>
                            </div>
                            <a href="#" className='privacy-policy'>Privacy Policy</a>
                        </div>
                    </Container>
                </div>
            </footer>
        </>
    );
}

export default Footer;
